import { useQuery } from "@tanstack/react-query";
import { getKlaviyoMappings } from "../../api/bKlaviyoApi";

export const useGetKlaviyoMappings = (organisationId) => {
  return useQuery({
    queryKey: ["klaviyo-mappings", organisationId],
    queryFn: () => getKlaviyoMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Klaviyo mappings:", error.response || error);
    },
  });
};
